<template>
  <v-card :loading="loading">

    <!-- Bouton partager url -->
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab small class="v-btn--share d-print-none" v-bind="attrs" v-on="on" v-show="!loading"><v-icon>mdi-share-variant</v-icon></v-btn>
      </template>
      <v-card>
        <v-card-title class="grey lighten-2">
          Partager la fiche
        </v-card-title>
        <!-- nécessaire pour pouvoir copier l'url dans le presse papier -->
        <v-text-field :value="url" ref="url" type="texte" dense class="ma-5"></v-text-field>
        <v-divider></v-divider>
        <v-card-actions justify>
          <v-spacer></v-spacer>
          <v-btn text @click="onClickCopyUrl">Copier le lien</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   

    <!-- Indicateur de chargement  -->
    <v-row v-show="loading">
      <v-col cols="12" class="pa-5">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        Veuillez patienter...
      </v-col>
    </v-row>

    <!-- Fiche  -->
    <v-row v-show="!loading">
      <!-- Partie gauche -->
      <v-col cols="12" md="8" class="px-5 py-0">
        <v-row>
          <v-col>
            <v-btn :to="'/listeimmo'" class="d-print-none btn-retour"><v-icon left>mdi-arrow-left</v-icon>Retour à la liste</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>{{ libelle }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <h3><v-icon left>mdi-map-marker</v-icon>Localisation</h3>
            <div class="text-gris pt-1">{{ codePostal }} {{ ville }}</div>
          </v-col>
          <v-col cols="12" sm="3" v-show="surfaceTotale > 0">
            <h3><v-icon left>mdi-texture-box</v-icon>Surface</h3>
            <div class="text-gris pt-1">{{ surfaceTotale | numberLocale }}</div>
          </v-col>
          <v-col cols="12" sm="3" v-show="loyerMensuel > 0">
            <h3><v-icon left>mdi-currency-eur</v-icon>Loyer mensuel</h3>
            <div class="text-gris pt-1">{{ loyerMensuel | numberLocale }}</div>
          </v-col>
          <v-col cols="12" sm="3" v-show="prixVente > 0">
            <h3><v-icon left>mdi-currency-eur</v-icon>Prix de vente</h3>
            <div class="text-gris pt-1">{{ prixVente | numberLocale }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h3><v-icon left>mdi-comment-text-outline</v-icon>Description</h3>
            <div v-html="descBien" class="text-gris text--darken-1 pt-1" />
          </v-col>
        </v-row>
      </v-col>
      <!-- Partie droite -->
      <v-col cols="12" md="4">
        <div v-for="(photo, i) in photos" :key="photo.id" class="pa-2" style="text-align: center">
          <!-- <v-img> n'est pas utilisé volontairement car la balise met l'image en arrière plan et par défaut, Chrome n'imprime pas les images d'arrière plan -->
          <img :src="photo.file" height="200" contain @error="onImageError(i)">
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  'use strict'

  import Objet from '../objet.js'

  export default {
    props : {
      propId : String
    },
    data(){
      return {
        // Propriété JSON du webservice
        codePostal   : '',
        descBien     : '',
        libelle      : '',
        idCrypte      : '',
        loyerMensuel : '',
        photos       : [],
        prixVente    : '',
        surfaceTotale: 0,
        ville        : '',
        // Autres data pour le fonctionnement de la fiche
        dialog : false,                // Statut d'affichage de la popup pour copier l'url
        loading: true,                 // Indicateur de chargement
        url    : window.location.href, // Saisie l'url de la fiche dans un champ input (Nécessaire pour pouvoir copier l'url dans le presse papier)
      }
    },
    /**
     * Retrouve l'offre à partir de l'id indiqué dans l'url
     */
    mounted(){
      var that = this
      document.title = "Bourse aux locaux"
      this.loading = true
      this.$store.commit('immobilier/idCrypte', decodeURIComponent(this.propId))
      this.$store.dispatch('immobilier/fiche', this.propId)
      .then(function(){
        that.loading = false
        var offre = that.$store.getters['immobilier/fiche']
        if (!offre.id){
          offre.libelle = "Offre immobilière introuvable"
        }
        Objet.copy(offre, that.$data) // Ecrase les données du composant pour actualiser la vue
      })
    },
    computed : {
      id            : { get(){ return this.$store.getters['immobilier/id']            }, set(Value){ this.$store.commit('immobilier/id'        , Value); }},
    },
    methods:{
      /**
       * Gère le cas des erreurs 404 pour les images
       */
      onImageError(Index){
        this.photos[Index].file = require('../assets/404.jpg')
      },
      /**
       * Copie l'url de la fiche dans le presse papier à des fins de partage
       */
      onClickCopyUrl(){
        this.$refs.url.$el.querySelector('input').select() // Sélectionne l'url dans l'input
        document.execCommand("copy")
        this.dialog = false // Cache la popup
      }
    },
    /*
    watch: {
      $route(to, from) {
        console.log("to : " + to.path.propId+ " / from : " + from.path.propId)
        this.$store.commit('immobilier/id', 1)
        this.$store.dispatch('immobilier/fiche', 1)
        
        
      },
    },
    */
  }
</script>

<style scoped>
  .v-btn--share{
    position: absolute;
    top     : 10px;
    right   : 10px;
    z-index : 1;
  }
</style>